// this is the left sidebar menu component, it only appears on larger screens
import { copyrightText, name } from "../../data/data";
import Menu from "./Menu";

export default function Sidebar() {
	return (
		<div className="dark:bg-gray-800 invisible lg:visible fixed w-full lg:w-72 h-screen flex flex-col items-center justify-center bg-gray-100">
			<div className="absolute top-6 w-full p-7 flex flex-col items-center">
				<img
					src="/images/about/1.jpg"
					alt="me"
					className="h-20 w-20 rounded-full object-cover mb-2"
				/>
				<div className="text-center">
					<h6 className="mb-0 uppercase font-semibold">
						{name.firstName} {name.surname}
					</h6>
				</div>
			</div>
			<Menu />
			<p className="absolute bottom-0 text-center py-6 italic text-gray-400 dark:text-gray-600 text-sm">
				&copy; {copyrightText}
			</p>
		</div>
	);
}
